module.exports = __webpack_public_path__ + "img/login-account-org.aefce9bd.png";